@import '~style-sheet-helpers/core.less';

.step-header {
  text-align: left;
  text-transform: capitalize;
}
